/**
 * 按"显示宽度"截断文本：中日韩等宽字符算 2，其它算 1。
 * 与后端 BoardProcessor::ClampBoardName 一致（总宽 <= 80，约 40 个汉字或 80 个字母）。
 */
export const BOARD_NAME_MAX_WIDTH = 80
/** 字符数上限（40 个汉字就是 40 个字符） */
export const BOARD_NAME_MAX_CHARS = 40

function isWide(cp: number): boolean {
  return (
    (cp >= 0x1100 && cp <= 0x115f) ||
    (cp >= 0x2e80 && cp <= 0xa4cf) ||
    (cp >= 0xac00 && cp <= 0xd7a3) ||
    (cp >= 0xf900 && cp <= 0xfaff) ||
    (cp >= 0xfe30 && cp <= 0xfe6f) ||
    (cp >= 0xff00 && cp <= 0xff60) ||
    (cp >= 0xffe0 && cp <= 0xffe6)
  )
}

export function clampBoardName(
  name: string,
  maxWidth = BOARD_NAME_MAX_WIDTH,
  maxChars = BOARD_NAME_MAX_CHARS,
): string {
  let width = 0
  let chars = 0
  let out = ''
  for (const ch of name) {
    const cp = ch.codePointAt(0) ?? 0
    const w = isWide(cp) ? 2 : 1
    // 两个上限都要满足：字符数 ≤ 40，显示宽度 ≤ 80
    if (chars + 1 > maxChars || width + w > maxWidth) break
    width += w
    chars += 1
    out += ch
  }
  return out
}
